import { Injectable } from '@angular/core';
import { EmbedUrlResponse, EntityId, EntityType, MetabaseAnalyticsService, UserDashboardListResponse } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, mergeMap, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseState } from '../state/base/base.state';

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService {
    private readonly metabaseEntityType: EntityType = 'BUSINESS_SUBJECT';

    public metabaseAnalyticsDashboards$ = this.getMetabaseAnalyticsDashboards();

    constructor(
        private metabase: MetabaseAnalyticsService,
        private store: Store,
    ) {}

    private getMetabaseAnalyticsDashboards(): Observable<UserDashboardListResponse> {
        return this.store.select(BaseState.getBS).pipe(
            mergeMap(bs => this.metabase.getDashboards(this.metabaseEntityType, bs.id, this.getAnalyticsApiBaseUrl())),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
    }

    public getDashboardEmbedUrl(dashboardUuid: string): Observable<string> {
        return this.getDashboardEmbedData(dashboardUuid).pipe(map(response => response.embedUrl));
    }

    public getDashboardEmbedData(dashboardUuid: string): Observable<EmbedUrlResponse> {
        return this.metabase.getDashboardEmbedUrl(dashboardUuid, this.metabaseEntityType, this.getMetabaseEntityId(), this.getAnalyticsApiBaseUrl());
    }

    private getAnalyticsApiBaseUrl(): string {
        const analyticsApiOrigin = new URL(`${environment.root.v3.protocol}${environment.root.v3.rootUrl}${environment.root.v3.port}`).origin;
        return `${analyticsApiOrigin}/analytics/api/v1`;
    }

    private getMetabaseEntityId(): EntityId {
        return this.store.selectSnapshot(BaseState.getBS).id;
    }
}
